import { createStopUnitTypes, decimal } from "dora-contracts";
import * as t from "io-ts";
import { createErrorReportingAsyncThunk } from "../../helpers";
import * as tPromise from "io-ts-promise";
import axios from "axios";
import { createSlice } from "@reduxjs/toolkit";

const prefix = "data/stop-unit-templates";

const {
  stopUnitTemplateT,
  stopUniteTemplatesT,
  addStopUnitTemplateT,
  updateStopUnitTemplateT,
} = createStopUnitTypes({
  decimal: decimal,
});

export type StopUnitTemplate = t.TypeOf<typeof stopUnitTemplateT>;
export type AddStopUnitTemplate = t.TypeOf<typeof addStopUnitTemplateT>;
export type UpdateStopUnitTemplate = t.TypeOf<typeof updateStopUnitTemplateT>;

type State = {
  entities: StopUnitTemplate[];
};

const initialState: State = {
  entities: [],
};

export const loadStopUnitTemplatesAndTeams = createErrorReportingAsyncThunk(
  `${prefix}/load-unit-templates-and-teams`,
  async () => {
    const { data } = await axios.get("/api/stop-unit-templates");
    return await tPromise.decode(stopUniteTemplatesT, data);
  }
);

export const createStopUnitTemplate = createErrorReportingAsyncThunk(
  `${prefix}/create-unit-template`,
  async (template: AddStopUnitTemplate): Promise<{ id: string }> => {
    const response = await axios.post("/api/stop-unit-templates", template);
    return response.data;
  }
);

export const updateStopUnitTemplate = createErrorReportingAsyncThunk(
  `${prefix}/update-unit-template`,
  async (input: { id: string; data: UpdateStopUnitTemplate }) => {
    const { id, data } = input;
    return await axios.put(`/api/stop-unit-templates/${id}`, data);
  }
);

export const deleteStopUnitTemplate = createErrorReportingAsyncThunk(
  `${prefix}/delete-unit-template`,
  async (templateId: string) => {
    return await axios.delete(`/api/stop-unit-templates/${templateId}`);
  }
);

// export const addTeamToStopUnitTemplate = createErrorReportingAsyncThunk(
//   `${prefix}/add-team-to-unit-template`,
//   async (input: { templateId: string; teamId: string }) => {
//     const { templateId, teamId } = input;
//     return await axios.post(
//       `/api/stop-unit-templates/${templateId}/team/${teamId}`
//     );
//   }
// );
//
// export const removeTeamFromStopUnitTemplate = createErrorReportingAsyncThunk(
//   `${prefix}/remove-team-from-unit-template`,
//   async (input: { templateId: string; teamId: string }) => {
//     const { templateId, teamId } = input;
//     return await axios.delete(
//       `/api/stop-unit-templates/${templateId}/team/${teamId}`
//     );
//   }
// );

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadStopUnitTemplatesAndTeams.fulfilled, (state, action) => {
        state.entities = action.payload;
      })
      .addCase(deleteStopUnitTemplate.fulfilled, (state, action) => {
        state.entities = state.entities.map((template) => ({
          ...template,
          ...(template.id === action.meta.arg
            ? {
                deleted: true,
              }
            : {}),
        }));
      });
  },
});

export default slice.reducer;
